import userService from "../../../services/users/userService";
import debounce from 'lodash/debounce';
import i18n from "../../../i18n/index";
import { create } from "lodash";

export default {
    data() {
        return {
            search: "",
            pagination: {
            page: 1,
            rowsPerPage: 10,
            sortBy: null,
            descending: false
            },
            itemsData: [],
            totalItems: 0,
            loading: false,
            headers: [{
                    text: i18n.t('headers.user'),
                    sortable: false,
                    value: "username"
                },
                {
                    text: i18n.t('headers.name'),
                    sortable: false,
                    value: "name"
                },
                {
                    text: i18n.t('headers.email'),
                    sortable: false,
                    value: "email"
                },
                {
                    text: i18n.t('headers.provider'),
                    sortable: false,
                    value: "idProvider.name"
                },
                {
                    text: i18n.t('headers.branch'),
                    sortable: false,
                    value: ""
                },
                {
                    text: i18n.t('headers.role'),
                    sortable: false,
                    value: "name"
                },
                {
                    text: i18n.t('headers.status'),
                    sortable: false,
                    value: "status"
                }
            ],
            rowsPerPageItems: [10, 20, 50, 100],
           
            
        };
    },
    created() {
    
    this.fetchUsersDebounced = debounce(() => {
      this.searchUser();
    }, 500);
  },
    props: {},
    watch: {
    pagination: {
        handler() {
        this.searchUser();
        },
        deep: true,
    },
    search() {
         this.pagination.page = 1;
        this.fetchUsersDebounced(); 
    },
    },
    mounted() {
        this.searchUser(); 
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        async searchUser() {
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;

            try {
            const response = await userService.getUser({
                page,
                limit: rowsPerPage,
                search: this.search,
            });

            this.itemsData = response.data.data;      
            this.totalItems = response.data.total;
            } catch (error) {
            console.error("Error fetching users:", error);
            } finally {
            this.loading = false;
            }
        },
        searchOneUser() {
            userService.getUserOne(this.search).then(data => {
                this.itemsData = "";
                this.itemsData.push(data.data);
            });
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["name"], search));
        }
    },
};